import { Badge } from "../ui/badge";
import {
  BookOpen,
  PenTool,
  Calculator,
  Globe,
  FileText,
  Sparkles,
  FlaskConical,
  Clock,
  MapPin,
  Palette,
  Activity,
  Users,
  Coffee,
  Sun,
  Utensils,
} from "lucide-react";

// Metadata constants
export const NIVEAUX = [
  { value: "ps", label: "PS", color: "bg-pink-100 text-pink-700 border-pink-200" },
  { value: "ms", label: "MS", color: "bg-rose-100 text-rose-700 border-rose-200" },
  { value: "gs", label: "GS", color: "bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200" },
  { value: "cp", label: "CP", color: "bg-blue-100 text-blue-700 border-blue-200" },
  { value: "ce1", label: "CE1", color: "bg-green-100 text-green-700 border-green-200" },
  { value: "ce2", label: "CE2", color: "bg-yellow-100 text-yellow-700 border-yellow-200" },
  { value: "cm1", label: "CM1", color: "bg-orange-100 text-orange-700 border-orange-200" },
  { value: "cm2", label: "CM2", color: "bg-red-100 text-red-700 border-red-200" },
  { value: "6e", label: "6e", color: "bg-violet-100 text-violet-700 border-violet-200" },
];

// MATIERES avec couleurs cohérentes pour tout l'app (inspirées d'Edumoov)
export const MATIERES = [
  { value: "lecture", label: "Lecture", icon: BookOpen, color: "#3B82F6", bgColor: "bg-blue-500", lightColor: "bg-blue-50 text-blue-700", domain: "Français" },
  { value: "grammaire", label: "Grammaire", icon: PenTool, color: "#6366F1", bgColor: "bg-indigo-500", lightColor: "bg-indigo-50 text-indigo-700", domain: "Français" },
  { value: "dictee", label: "Dictée", icon: FileText, color: "#8B5CF6", bgColor: "bg-violet-500", lightColor: "bg-violet-50 text-violet-700", domain: "Français" },
  { value: "ecriture", label: "Écriture", icon: PenTool, color: "#A855F7", bgColor: "bg-purple-500", lightColor: "bg-purple-50 text-purple-700", domain: "Français" },
  { value: "oral", label: "Oral", icon: Users, color: "#7C3AED", bgColor: "bg-violet-600", lightColor: "bg-violet-50 text-violet-700", domain: "Français" },
  { value: "math", label: "Mathématiques", icon: Calculator, color: "#EF4444", bgColor: "bg-red-500", lightColor: "bg-red-50 text-red-700", domain: "Mathématiques" },
  { value: "anglais", label: "Langue vivante", icon: Globe, color: "#EC4899", bgColor: "bg-pink-500", lightColor: "bg-pink-50 text-pink-700", domain: "Langues" },
  { value: "sciences", label: "Questionner le monde", icon: FlaskConical, color: "#22C55E", bgColor: "bg-green-500", lightColor: "bg-green-50 text-green-700", domain: "Sciences" },
  { value: "histoire", label: "Histoire", icon: Clock, color: "#F59E0B", bgColor: "bg-amber-500", lightColor: "bg-amber-50 text-amber-700", domain: "Histoire-Géo" },
  { value: "geographie", label: "Géographie", icon: MapPin, color: "#84CC16", bgColor: "bg-lime-500", lightColor: "bg-lime-50 text-lime-700", domain: "Histoire-Géo" },
  { value: "arts", label: "Arts plastiques", icon: Palette, color: "#F97316", bgColor: "bg-orange-500", lightColor: "bg-orange-50 text-orange-700", domain: "Arts" },
  { value: "musique", label: "Éducation musicale", icon: Sparkles, color: "#FB923C", bgColor: "bg-orange-400", lightColor: "bg-orange-50 text-orange-700", domain: "Arts" },
  { value: "eps", label: "EPS", icon: Activity, color: "#14B8A6", bgColor: "bg-teal-500", lightColor: "bg-teal-50 text-teal-700", domain: "EPS" },
  { value: "emc", label: "EMC", icon: Users, color: "#0EA5E9", bgColor: "bg-sky-500", lightColor: "bg-sky-50 text-sky-700", domain: "EMC" },
  { value: "recreation", label: "Récréation", icon: Coffee, color: "#FBBF24", bgColor: "bg-yellow-400", lightColor: "bg-yellow-50 text-yellow-700", domain: "Pause" },
  { value: "accueil", label: "Accueil", icon: Sun, color: "#FCD34D", bgColor: "bg-yellow-300", lightColor: "bg-yellow-50 text-yellow-700", domain: "Organisation" },
  { value: "repas", label: "Pause méridienne", icon: Utensils, color: "#A3A3A3", bgColor: "bg-neutral-400", lightColor: "bg-neutral-50 text-neutral-700", domain: "Pause" },
  { value: "rituels", label: "Rituels", icon: Clock, color: "#FB7185", bgColor: "bg-rose-400", lightColor: "bg-rose-50 text-rose-700", domain: "Organisation" },
  { value: "autre", label: "Autre", icon: Sparkles, color: "#64748B", bgColor: "bg-slate-500", lightColor: "bg-slate-50 text-slate-700", domain: "Autre" },
];

// Mapping matière -> discipline officielle (pour la répartition horaire)
export const MATIERE_TO_DISCIPLINE = {
  "lecture": "Français",
  "grammaire": "Français",
  "dictee": "Français",
  "ecriture": "Français",
  "oral": "Français",
  "math": "Mathématiques",
  "anglais": "Langue vivante",
  "sciences": "Questionner le monde",
  "histoire": "Histoire et géographie",
  "geographie": "Histoire et géographie",
  "arts": "Enseignements artistiques",
  "musique": "Enseignements artistiques",
  "eps": "Éducation physique et sportive",
  "emc": "Enseignement moral et civique",
};

export const RESOURCE_TYPES = [
  { value: "texte", label: "Texte" },
  { value: "fiche", label: "Fiche" },
  { value: "exercice", label: "Exercice" },
  { value: "evaluation", label: "Evaluation" },
  { value: "sequence", label: "Sequence" },
  { value: "jeu", label: "Jeu" },
];

export const STATUSES = [
  { value: "draft", label: "Brouillon", color: "bg-slate-100 text-slate-600" },
  { value: "ready", label: "Pret", color: "bg-green-100 text-green-700" },
  { value: "shared", label: "Partage", color: "bg-blue-100 text-blue-700" },
  { value: "archived", label: "Archive", color: "bg-gray-100 text-gray-500" },
];

export const JOURNAL_STATUSES = [
  { value: "prevu", label: "Prevu", color: "bg-blue-100 text-blue-700" },
  { value: "fait", label: "Fait", color: "bg-green-100 text-green-700" },
  { value: "reporte", label: "Reporte", color: "bg-orange-100 text-orange-700" },
  { value: "annule", label: "Annule", color: "bg-red-100 text-red-700" },
];

export const SESSION_TYPES = [
  { value: "decouverte", label: "Decouverte", color: "bg-purple-100 text-purple-700" },
  { value: "entrainement", label: "Entrainement", color: "bg-blue-100 text-blue-700" },
  { value: "evaluation", label: "Evaluation", color: "bg-orange-100 text-orange-700" },
  { value: "remediation", label: "Remediation", color: "bg-yellow-100 text-yellow-700" },
  { value: "projet", label: "Projet", color: "bg-green-100 text-green-700" },
  { value: "autre", label: "Autre", color: "bg-slate-100 text-slate-700" },
];

export const getSessionTypeInfo = (type) => SESSION_TYPES.find(t => t.value === type) || SESSION_TYPES[1];

// Helper functions
export const getNiveauInfo = (niveau) => NIVEAUX.find(n => n.value === niveau) || NIVEAUX[1];
export const getMatiereInfo = (matiere) => MATIERES.find(m => m.value === matiere) || MATIERES[5];
export const getResourceTypeInfo = (type) => RESOURCE_TYPES.find(t => t.value === type) || RESOURCE_TYPES[0];
export const getStatusInfo = (status) => STATUSES.find(s => s.value === status) || STATUSES[0];
export const getJournalStatusInfo = (status) => JOURNAL_STATUSES.find(s => s.value === status) || JOURNAL_STATUSES[0];

// Badge Components
export function NiveauBadge({ niveau, className = "" }) {
  const info = getNiveauInfo(niveau);
  return (
    <Badge variant="outline" className={`${info.color} font-semibold ${className}`}>
      {info.label}
    </Badge>
  );
}

export function MatiereBadge({ matiere, className = "" }) {
  const info = getMatiereInfo(matiere);
  const Icon = info.icon;
  return (
    <Badge variant="outline" className={`${info.lightColor} font-medium ${className}`}>
      <Icon className="w-3 h-3 mr-1" />
      {info.label}
    </Badge>
  );
}

export function ResourceTypeBadge({ type, className = "" }) {
  const info = getResourceTypeInfo(type);
  return (
    <Badge variant="secondary" className={`font-medium ${className}`}>
      {info.label}
    </Badge>
  );
}

export function StatusBadge({ status, className = "" }) {
  const info = getStatusInfo(status);
  return (
    <Badge variant="outline" className={`${info.color} font-medium ${className}`}>
      {info.label}
    </Badge>
  );
}

export function JournalStatusBadge({ status, className = "" }) {
  const info = getJournalStatusInfo(status);
  return (
    <Badge variant="outline" className={`${info.color} font-medium ${className}`}>
      {info.label}
    </Badge>
  );
}

// Format date helpers
export function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
  });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatRelativeTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);
  
  if (diffMins < 1) return "A l'instant";
  if (diffMins < 60) return `Il y a ${diffMins} min`;
  if (diffHours < 24) return `Il y a ${diffHours}h`;
  if (diffDays === 1) return "Hier";
  if (diffDays < 7) return `Il y a ${diffDays} jours`;
  return formatDate(dateStr);
}
